import {Collapse, Grid} from '@mui/material';
import {memo, useState, useCallback} from 'react';

import MhdSelect from '../../atomicComponents/MhdSelect';
import MhdInput from '../../atomicComponents/MhdInput';
import MhdWidgetDivider from '../../atomicComponents/MhdWidgetDivider';
import {gridChoices} from '../../../utils/choices';
import {setAndUpdate, validateAndUpdate} from "../../../utils/helpers";

const ViewWidget = ({data, mods, warn, errs, update, setter, shared}) => {
  const [customXAxis, setCustomXAxis] = useState(false)
  const [customYAxis, setCustomYAxis] = useState(false)

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <MhdSelect
          label='Grid'
          value={data.grid ? data.grid : 'null'}
          onChange={useCallback((v) => setAndUpdate('grid', v, setter, update), [])}
          choices={gridChoices}
        />
      </Grid>
      <Grid item xs={12}>
        <MhdWidgetDivider
            label='X AXIS'
            value={customXAxis}
            onChange={setCustomXAxis}
        >
          <Collapse in={customXAxis}>
            <Grid container spacing={1} pt={'2px'}>
              <Grid item xs={4}>
                <MhdInput
                  label='Ticks'
                  value={data.xaxis_ticks}
                  override={mods.xaxis_ticks}
                  warning={warn.xaxis_ticks}
                  error={errs.xaxis_ticks}
                  onChange={useCallback((v) => validateAndUpdate('xaxis_ticks', v, setter, update), [])}
                  units={shared?.slice_widget?.slice === 'r' ? 'R⊙' : '°'}
                />
              </Grid>
              <Grid item xs={4}>
                <MhdInput
                  label='Min'
                  value={data.xaxis_min}
                  override={mods.xaxis_min}
                  warning={warn.xaxis_min}
                  error={errs.xaxis_min}
                  onChange={useCallback((v) => validateAndUpdate('xaxis_min', v, setter, update), [])}
                  units={shared?.slice_widget?.slice === 'r' ? 'R⊙' : '°'}
                />
              </Grid>
              <Grid item xs={4}>
                <MhdInput
                  label='Max'
                  value={data.xaxis_max}
                  override={mods.xaxis_max}
                  warning={warn.xaxis_max}
                  error={errs.xaxis_max}
                  onChange={useCallback((v) => validateAndUpdate('xaxis_max', v, setter, update), [])}
                  units={shared?.slice_widget?.slice === 'r' ? 'R⊙' : '°'}
                />
              </Grid>
            </Grid>
          </Collapse>
        </MhdWidgetDivider>
      </Grid>
      <Grid item xs={12}>
        <MhdWidgetDivider
            label='Y AXIS'
            value={customYAxis}
            onChange={setCustomYAxis}
        >
          <Collapse in={customYAxis}>
            <Grid container spacing={1} pt={'2px'}>
              <Grid item xs={4}>
                <MhdInput
                  label='Ticks'
                  value={data.yaxis_ticks}
                  override={mods.yaxis_ticks}
                  warning={warn.yaxis_ticks}
                  error={errs.yaxis_ticks}
                  onChange={useCallback((v) => validateAndUpdate('yaxis_ticks', v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <MhdInput
                  label='Min'
                  value={data.yaxis_min}
                  override={mods.yaxis_min}
                  warning={warn.yaxis_min}
                  error={errs.yaxis_min}
                  onChange={useCallback((v) => validateAndUpdate('yaxis_min', v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <MhdInput
                  label='Max'
                  value={data.yaxis_max}
                  override={mods.yaxis_max}
                  warning={warn.yaxis_max}
                  error={errs.yaxis_max}
                  onChange={useCallback((v) => validateAndUpdate('yaxis_max', v, setter, update), [])}
                />
              </Grid>
            </Grid>
          </Collapse>
        </MhdWidgetDivider>
      </Grid>
    </Grid>
  );
}

export default memo(ViewWidget);